import { BackArrow } from "lola-framework-ui-test";
import type { JSX } from "react";
import { renderBankAccountLine } from "../../../../utils/bankAccountLine";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
  /**
   * Saved instrument that cannot be used on this route. Stays clickable so
   * the picker can explain why.
   */
  unavailable?: boolean;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange = () => {},
  color = "#252525",
  fee,
  className = "",
  unavailable = false,
}) => {
  return (
    <section
      className={`payout-container-content glass gradient-card ${unavailable ? "funding-unavailable" : ""} ${className}`.trim()}
      onClick={onChange}
    >
      <section className="payout-container-info">
        <section className="payout-icon-container">{icon}</section>
        <p className="payout-text-info foreground">
          {renderBankAccountLine(title)}
          <label className="muted-foreground">{renderBankAccountLine(subtitle)}</label>
        </p>
      </section>
      {fee ? (
        fee
      ) : unavailable ? (
        <span
          className="funding-unavailable-info"
          aria-hidden="true"
          style={{ color }}
        >
          i
        </span>
      ) : (
        <BackArrow className="right-icon flavor-c-icon" size={30} colors={[color, color]} />
      )}
    </section>
  );
};
